<template>
    <div class="aba-tabpreco">
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-usuario-ass"
                    />
                </div>

                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularUsuario"
                    >
                        {{ $t('vincular-usuario') }}
                    </button>
                </div>

                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'usuario-gerenciar-new',
                                query: { tela: 'tabelapreco-usuario', id: $route.params.id },
                            })
                        "
                    >
                        {{ $t('adicionar-usuario') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="asstabprecousuario"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'nome'">
                            <!-- Leva para a página de exibição completa dos dados do usuário -->
                            <router-link
                                :to="{
                                    name: 'usuario-gerenciar-edit',
                                    params: { id: +props.row.idusuario },
                                    query: { tela: 'tabelapreco-usuario', id: $route.params.id },
                                }"
                                :title="$t('msg-ver-dados-completos-usuario')"
                            >
                                <HideInfo
                                    v-if="!cleanHide"
                                    :value="props.row[f.key]"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                />
                            </router-link>
                        </div>

                        <div v-else-if="f.key == 'login'">
                            <HideInfo
                                v-if="!cleanHide"
                                :value="props.row[f.key]"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                            />
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assTabPrecoUsuarioIntegracao"
                                class="action-button"
                                :type="
                                    props.row['replicapda'] == 3
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['replicapda'] == 3 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <VendedorModal
                        :idTabPreco="$route.params.id"
                        :permissaoVincular="!assTabPrecoUsuarioIntegracao"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssTabPrecoUsuarioService from '@/services/vendas/tabpreco/AssTabPrecoUsuarioService';
import VendedorModal from '@/components/vendas/tabelapreco/modal/UsuarioModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import HideInfo from '@/components/shared/HideInfo';

// UTILS
import { mapState } from 'vuex';

export default {
    components: {
        ContainerLoader,
        VendedorModal,
        HideInfo,
    },
    data() {
        return {
            cleanHide: true,
            assTabPrecoUsuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSTABPRECOUSUARIO'
            ),
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('USUARIO'),
            asstabprecousuario: [],
            fields: [
                { key: 'codigo', width: '10%', sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'login', width: null, sortable: true, sortFn: null },
                { key: 'replicapda', width: 80, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new AssTabPrecoUsuarioService(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            permissaoCadastroUsuario: false,

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,
        };
    },
    computed: {
        ...mapState(['hide']),
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-tabelapreco');

        this.permissaoCadastroUsuario = this.hasPermissionAccess(
            'admin',
            'gerenciar-usuarios',
            'admin-gerenciar-usuarios'
        );

        this.permissaoVincular = this.permissao.create && !this.assTabPrecoUsuarioIntegracao;
        this.permissaoCadastrar = this.permissaoCadastroUsuario.create && !this.usuarioIntegracao;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'tabelapreco' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    this.$route.params.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.asstabprecousuario = value;
                    this.isEmpty = this.asstabprecousuario.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idasstabprecousuario: m.id,
                    idusuario: m.usuario.idusuario,
                    codigo: m.usuario.idusuarioerp,
                    nome: m.usuario.nome,
                    login: m.usuario.login,
                    replicapda: m.replicapda,
                    excluir: 'excluir',
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            // Aviso dinâmico passado o nome do usuário
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirma-desativar-ass-n'
                        : 'msg-confirma-reativar-ass-n', 
                    { n: row['nome'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempAssTabPrecoUsuario = {
                idasstabprecousuario: this.delete.idasstabprecousuario,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempAssTabPrecoUsuario)
                .then((r) => {
                    if (r.status == 200) {
                        // Aviso dinâmico passado o nome do usuário
                        let tempSuccess = this.$t(
                                this.delete.replicapda == 3
                                    ? 'msg-sucesso-ao-reativar-ass-n'
                                    : 'msg-sucesso-ao-desativar-ass-n', 
                                { n: this.delete.nome }
                            );

                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    // Aviso dinâmico passado o nome do usuário
                    let msg = this.$t(
                            this.delete.replicapda == 2
                                ? 'msg-erro-ao-desativar-ass-n'
                                : 'msg-erro-ao-reativar-ass-n', 
                            { n: this.delete.nome }
                        );

                    this.$root.showMessage('error', msg, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalVincularUsuario() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-tabpreco {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
